export default __webpack_public_path__ + "static/media/engagement.c79d5ad5.jpg";